import { motion } from 'framer-motion';

import Card from '../../components/Card';
import BackButton from '../../components/BackButton/BackButton';
import { titleSection } from '../../animations/PageAnimations';
import { ICard } from '../../types';
import { useAppSelector } from '../../hooks';
import { selectSectionById } from '../../store/WebSettingsSlice';

// import { ChatBotOverlay } from '../../components/ChatBotOverlay';

const RequestService = () => {

  const ID_SECTION = 'services';
  const section = useAppSelector(state => selectSectionById(state, ID_SECTION));

  return (
    <section className="mx-auto px-12 pt-8">
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        key="title-accounts"
        variants={titleSection}
      >
        <BackButton />
        <h1 className="mt-4 xl:mt-6 font-bold"
          dangerouslySetInnerHTML={{__html:section?.title || ''}}/>
      </motion.div>

      <motion.div className="mt-6 xl:mt-8"
        key="content-accounts"
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <div className="cards-icons-top cards-small grid grid-cols-4 gap-4 xl:gap-8">
          {section?.cards?.map((card, index) =>
            (
              <Card
                {...card}
                key={card.id}
                index={index+1}
              />
            )
          )}
        </div>

        <div className="mt-4 xl:mt-8 cards-icons-top cards-small grid grid-cols-4 gap-3 xl:gap-5">
          {section?.bottomCards?.map((card, index) =>
            (
              <Card
                {...card as ICard}
                index={index+4}
                key={card.id}
              />
            )
          )}
        </div>

      </motion.div>

      {/* <ChatBotOverlay /> */}

    </section>
  );
};
export default RequestService;
